import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { goBack } from 'connected-react-router';
import { t } from 'i18next';
import * as R from 'ramda';
import { path } from 'ramda';
import React, { useEffect, useState, useCallback } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { companyActions } from '../../../modules/company';
import { reviewActions } from '../../../modules/review';
import extractParam from '../../../utils/helpers/extractParam';
import { useForm } from '../../../utils/hooks/useForm';
import { DisplayFlexS } from '../../../utils/stylesHelpers';
import NoLogo from '../../assets/imgs/icons/NOlogo_Icon.svg';
import ProfileIcon from "../../assets/imgs/icons/User_icon.svg";
import {  Text, TextInput } from '../common';
import {  ContentWrapS } from '../company/companyItemS';

import { 
  GoBackBtnWrapResponsiveS,
  GoBackBtnTextS,
  GoBackBtnIconS, 
  BaseBlockStyledResponsive,
  DisplayFlexResponsiveS,
  DisplayFlexRatingS,
  AvatarWrapperS,
  AvatarS,
  InfoBlockHeaderS,
  CreateCommentsBlockHeaderS,
  FormS,
  RatingTextS,
  RatingS,
  InputWrapS,
  TextAreaS,
  DisplayFlexButtonS,
  ButtonS
} from "./reviewComponentS";

const { createCompanyReview, createOwnerAnswer, updateCompanyRating } = reviewActions;
const { fetchCompanyItem } = companyActions;

export const REVIEW_VIEW_MODE = {
  GUEST: 'guest',
  LOGGED_IN_USER: 'user', // indicate user and company
  OWNER: 'owner'
};

const validationSchema = Yup.object().shape({
  createdBy: Yup.object().shape({
    name: Yup.string().required(t('reviewCreate.nameValidationRequired')),
    email: Yup.string()
      .email(t('reviewCreate.emailIsNotValid'))
      .required(t('reviewCreate.emailValidationRequired'))
  })
});


 /*
*   it can work for admin answer and for regular review
* */
const ReviewComponent = () => {

  const dispatch = useDispatch();

  const [isOwnerAnswer, setIsOwnerAnswer] = useState(false);
  const [viewMode, setViewMode] = useState(REVIEW_VIEW_MODE.GUEST);
  const [rating, setRating] = useState(0);

  const location = useSelector((state) => state.router.location);
  const loggedInCompany = useSelector((state) => state.auth.activeUser); // here will be company object
  const companyToAddReviewTo = useSelector((state) => state.company.companyItem);
  const isPostingReview = useSelector((state) => state.review.loading);

  const companyId =  location.pathname.split('/')[2];

  useEffect(() => {
    dispatch(fetchCompanyItem(companyId));
    setIsOwnerAnswer(extractParam('owner', location.search));
  }, [companyId, location]);

  useEffect(() => {
    if (isOwnerAnswer) {
      setViewMode(REVIEW_VIEW_MODE.OWNER);
    } else if (path(['email'], loggedInCompany) || path(['base', 'email'], loggedInCompany)) {
      setViewMode(REVIEW_VIEW_MODE.LOGGED_IN_USER);
    } else {
      setViewMode(REVIEW_VIEW_MODE.GUEST);
    }
  }, [isOwnerAnswer, loggedInCompany]);

  const postUserRating = useCallback(
    (values) => {
      dispatch(updateCompanyRating({
        score: rating,
        belongTo: companyToAddReviewTo._id,
        createdBy: {
          name: values.createdBy.name,
          email: values.createdBy.email
        }
      }));
    },
    [ rating, companyToAddReviewTo]
  );

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);

    if (isOwnerAnswer) {
      dispatch(createOwnerAnswer({
        _id: extractParam('review', location.search),
        companyAnswer: values.text,
        belongTo: loggedInCompany._id
      }));
    } else {
      dispatch(createCompanyReview({
        ...values,
        belongTo: companyToAddReviewTo._id,
        ...(rating && rating !== 0 ? { rating } : {})
      }));
    }
    resetForm();
  };

  const initialValues = {
    createdBy: {
      id: viewMode !== REVIEW_VIEW_MODE.GUEST ? path(['_id'], loggedInCompany) : null,
      name: 
       viewMode !== REVIEW_VIEW_MODE.GUEST && path(['name'], loggedInCompany) ? path(['name'], loggedInCompany) : '',
      email: 
       viewMode !== REVIEW_VIEW_MODE.GUEST 
         && path(['base', 'email'], loggedInCompany) ? path(['base', 'email'], loggedInCompany) : ''
     },
     text: '',
  };

  const {
    values,
    errors,
    touched,
    onChange,
    onBlur,
    onSubmit
  } = useForm({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
  <ContentWrapS>
    <GoBackBtnWrapResponsiveS onClick={() => dispatch(goBack())}>
      <GoBackBtnIconS fontFamily='bold' color='red'>
        <FontAwesomeIcon  icon='chevron-left' />
      </GoBackBtnIconS>
      <GoBackBtnTextS fontFamily='bold'>
        <Trans i18nKey='companyItem.goBackProfile' />
      </GoBackBtnTextS>
    </GoBackBtnWrapResponsiveS>
    <BaseBlockStyledResponsive>
      <CreateCommentsBlockHeaderS>
        <Trans i18nKey="reviewCreate.header" />
      </CreateCommentsBlockHeaderS>

      <DisplayFlexResponsiveS>
        <AvatarWrapperS>
          {
            /*for Guest and Logged User */
            viewMode !== REVIEW_VIEW_MODE.OWNER && (
              <>
                <AvatarS isLoggedIn={loggedInCompany}>
                  <img 
                    src={ loggedInCompany ? loggedInCompany.logo || NoLogo : ProfileIcon } 
                    alt={ loggedInCompany ? `${loggedInCompany.name} logo` : "guest avatar" }
                    data-logo={loggedInCompany && loggedInCompany.logo ? "true" : "false"}
                  />
                </AvatarS>
                <Text fontFamily="bold" color="darkerViolet">
                  {loggedInCompany ? loggedInCompany.name : <Trans i18nKey="reviewCreate.userName" />}
                </Text>
              </>
            )
          }
        </AvatarWrapperS>
        <InfoBlockHeaderS>
          <Trans i18nKey={`reviewCreate.headersCaptures.${isOwnerAnswer ? 'ownerAnswer' : 'info'}`} />
        </InfoBlockHeaderS>
        <FormS style={{ width: '100%' }} {...{ onSubmit }}>
          {
            /*for Guest and Logged User */
            viewMode !== REVIEW_VIEW_MODE.OWNER && (
              <>
                <DisplayFlexRatingS direction="column" style={{ marginBottom: '30px' }} >
                  <RatingTextS fontFamily="bold" color="darkerViolet" style={{ marginBottom: '12px' }}>
                    <Trans i18nKey="reviewCreate.ratingCapture" />
                  </RatingTextS>
                  <RatingS
                    selectedRating={rating}
                    setRating={setRating}
                  />
                </DisplayFlexRatingS>

                <DisplayFlexS 
                  justify="space-between" 
                  justifyScreenMedium="space-between" 
                  directionScreenMedium='column'
                >

                  <InputWrapS width="45%">
                    <TextInput
                      disabled={loggedInCompany && loggedInCompany.name}
                      label={t('reviewCreate.userDataForm.labels.name')}
                      name="createdBy.name"
                      type="text"
                      value={ values.createdBy.name }
                      {...{ onChange, onBlur }}
                      isError={errors.createdBy && errors.createdBy.name && touched.createdBy && touched.createdBy.name}
                      error={errors.createdBy && errors.createdBy.name}
                    />
                  </InputWrapS>
                </DisplayFlexS>

                <DisplayFlexS  
                  justify="space-between" 
                  justifyScreenMedium="space-between" 
                  directionScreenMedium='column'
                >

                  <InputWrapS width="45%">
                    <TextInput
                      disabled={loggedInCompany && loggedInCompany.base.email}
                      label={t('reviewCreate.userDataForm.labels.email')}
                      name="createdBy.email"
                      type="text"
                      value={ values.createdBy.email }
                      {...{ onChange, onBlur }}
                      isError={R.path(['createdBy', 'email'], errors) && R.path(['createdBy', 'email'], touched)}
                      error={R.path(['createdBy', 'email'], errors)}
                    />
                  </InputWrapS>
                </DisplayFlexS>
              </>
            )
          }
          <DisplayFlexS>
            <InputWrapS>
              <TextAreaS
                label={t('reviewCreate.userDataForm.labels.text')}
                name="text"
                type="text"
                value={R.prop('text', values)}
                rows="10"
                isError={errors.text && touched.text}
                error={errors.text}
                {...{ onChange, onBlur }}
              />
            </InputWrapS>
          </DisplayFlexS>

          <DisplayFlexButtonS justifyScreenMedium="center">
            <ButtonS
              type="button"
              onClick={() =>
                rating && R.path(['createdBy', 'name'], values) && !values.text
                  ? postUserRating(values)
                  : onSubmit()
              }
              padding='5px 25px'
              loading={isPostingReview}
            >
              <Trans i18nKey="reviewCreate.submitBtn" />
            </ButtonS>
          </DisplayFlexButtonS>
        </FormS>

      </DisplayFlexResponsiveS>

    </BaseBlockStyledResponsive>
  </ContentWrapS>
  )
};

export default ReviewComponent;

